import { lazy } from 'react';

const ImageCardsCarousel = lazy(() => import('../ImageCardsCarousel'));

const ImageCardsCarouselLazy = () => {
  return <ImageCardsCarousel />;
};

export default ImageCardsCarouselLazy; 